// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../utils/Utils.bs.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Core__Null = require("@rescript/core/src/Core__Null.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactSelect = require("../../reason/bindings/ReactSelect.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReactSelect$1 = require("react-select").default;
var JsxRuntime = require("react/jsx-runtime");
var Async = require("react-select/async").default;
var AsyncCreatable = require("react-select/async-creatable").default;

var indicatorStyle = {
  color: "var(--color-silver-sand)",
  padding: "5px 8px",
  ":hover": {
    color: "var(--color-dove-gray)"
  }
};

function borderColor(state, activeBorderColor, inActiveBorderColor, hoverBorderColor) {
  return {
          borderColor: state.menuIsOpen || state.isFocused ? activeBorderColor : inActiveBorderColor,
          ":hover": state.menuIsOpen ? ({
                borderColor: activeBorderColor
              }) : ({
                borderColor: hoverBorderColor
              })
        };
}

function defaultBorderColor(state) {
  return borderColor(state, "var(--color-tan-focused-border)", "var(--color-alto)", "var(--color-silver)");
}

function errorBorderColor(state) {
  return borderColor(state, "var(--color-tan-focused-border)", "var(--color-tan-error-500)", "var(--color-tan-error-500)");
}

function okBorderColor(state) {
  return borderColor(state, "var(--color-tan-focused-border)", "var(--color-tan-success)", "var(--color-tan-success)");
}

var defaultStyles_option = (function (provided, state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                state.isFocused ? ({
                      backgroundColor: "var(--color-tan-blue-500)",
                      color: "var(--color-white)"
                    }) : ({}),
                state.isSelected ? ({
                      backgroundColor: "rgba(0,126,255,.04)",
                      color: "#333"
                    }) : ({})
              ]);
  });

var defaultStyles_menu = (function (provided, state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                defaultBorderColor(state),
                {
                  backgroundColor: "var(--color-white)",
                  marginTop: "0",
                  zIndex: "6",
                  borderRadius: "0"
                }
              ]);
  });

var defaultStyles_control = (function (provided, state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                defaultBorderColor(state),
                {
                  backgroundColor: "var(--color-white)",
                  display: "flex",
                  minHeight: "36px",
                  borderRadius: "0.125rem",
                  boxShadow: "none",
                  flexWrap: "wrap"
                }
              ]);
  });

var defaultStyles_input = (function (provided, param) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  display: "flex",
                  ":hover": {
                    cursor: "text"
                  }
                }
              ]);
  });

var defaultStyles_placeholder = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  color: "var(--color-gray)",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  width: "100%",
                  textOverflow: "ellipsis",
                  pointerEvents: "none"
                }
              ]);
  });

var defaultStyles_multiValue = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  backgroundColor: "var(--color-tan-blue-500)",
                  color: "var(--color-white)",
                  padding: "2px"
                }
              ]);
  });

var defaultStyles_multiValueLabel = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  color: "var(--color-white)",
                  fontSize: "14px"
                }
              ]);
  });

var defaultStyles_multiValueRemove = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  ":hover": {
                    backgroundColor: "var(--color-white)",
                    color: "var(--color-tan-blue-500)"
                  }
                }
              ]);
  });

var defaultStyles_groupHeading = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  backgroundColor: "var(--color-gallery)",
                  color: "var(--color-jumbo)",
                  fontSize: "14px",
                  margin: "0",
                  padding: "10px"
                }
              ]);
  });

var defaultStyles_clearIndicator = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                indicatorStyle
              ]);
  });

var defaultStyles_dropdownIndicator = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                indicatorStyle
              ]);
  });

var defaultStyles_valueContainer = (function (provided, _state) {
    return ReactSelect.Styles.combineManyStyles([
                provided,
                {
                  padding: "0px 8px"
                }
              ]);
  });

var defaultStyles = {
  option: defaultStyles_option,
  menu: defaultStyles_menu,
  control: defaultStyles_control,
  input: defaultStyles_input,
  placeholder: defaultStyles_placeholder,
  multiValue: defaultStyles_multiValue,
  multiValueLabel: defaultStyles_multiValueLabel,
  multiValueRemove: defaultStyles_multiValueRemove,
  groupHeading: defaultStyles_groupHeading,
  clearIndicator: defaultStyles_clearIndicator,
  dropdownIndicator: defaultStyles_dropdownIndicator,
  valueContainer: defaultStyles_valueContainer
};

var newrecord = Caml_obj.obj_dup(defaultStyles);

newrecord.control = (function (provided, state) {
    return ReactSelect.Styles.combineManyStyles([
                Core__Option.getOr(Core__Option.map(defaultStyles_control, (function (c) {
                            return c(provided, state);
                          })), {}),
                errorBorderColor(state)
              ]);
  });

var newrecord$1 = Caml_obj.obj_dup(defaultStyles);

newrecord$1.control = (function (provided, state) {
    return ReactSelect.Styles.combineManyStyles([
                Core__Option.getOr(Core__Option.map(defaultStyles_control, (function (c) {
                            return c(provided, state);
                          })), {}),
                okBorderColor(state)
              ]);
  });

var Styles = {
  indicatorStyle: indicatorStyle,
  borderColor: borderColor,
  defaultBorderColor: defaultBorderColor,
  errorBorderColor: errorBorderColor,
  okBorderColor: okBorderColor,
  defaultStyles: defaultStyles,
  errorStyles: newrecord,
  okStyles: newrecord$1
};

function ref(externalRef, selectRef) {
  return function (domRef) {
    var r = Core__Option.map((domRef == null) ? undefined : Caml_option.some(domRef), (function (prim) {
            return prim;
          }));
    Utils.React.setCurrentRef(selectRef, r);
    if (externalRef !== undefined) {
      return Utils.React.setCurrentRef(externalRef, r);
    }
    
  };
}

var SelectRef = {
  ref: ref
};

var Types = {};

function noOptionsMessage(noOptionsMessage$1) {
  return function (v) {
    var v$1 = noOptionsMessage$1(v.inputValue);
    if (v$1 !== undefined) {
      return v$1;
    } else {
      return null;
    }
  };
}

function statusToStyles(status) {
  switch (status) {
    case "Neutral" :
        return defaultStyles;
    case "Success" :
        return newrecord$1;
    case "Failure" :
        return newrecord;
    
  }
}

var Helpers = {
  noOptionsMessage: noOptionsMessage,
  statusToStyles: statusToStyles
};

function useCommonProps(input) {
  return {
          getOptionLabel: React.useCallback((function (opt) {
                  return input.getOptionLabel(ReactSelect.Options.unwrapOption(opt));
                }), [input.getOptionLabel]),
          getOptionValue: React.useCallback((function (opt) {
                  return input.getOptionValue(ReactSelect.Options.unwrapOption(opt));
                }), [input.getOptionValue]),
          formatOptionLabel: React.useCallback(Core__Option.map(input.formatOptionLabel, (function (formatOptionLabel) {
                      return function (opt, context) {
                        return formatOptionLabel(ReactSelect.Options.unwrapOption(opt), context);
                      };
                    })), [input.formatOptionLabel])
        };
}

function useOptions(input) {
  return React.useMemo((function () {
                return Core__Option.map(input, (function (options) {
                              return options.map(ReactSelect.Options.wrapOption);
                            }));
              }), [input]);
}

function useLoadOptions(input) {
  return React.useCallback((function (string) {
                return input(string).then(function (options) {
                            return options.map(ReactSelect.Options.wrapOption);
                          });
              }), [input]);
}

function useLoadOptionsGroup(input) {
  return React.useCallback((function (string) {
                return input(string).then(function (options) {
                            return options.map(function (group) {
                                        return {
                                                label: group.label,
                                                options: group.options.map(ReactSelect.Options.wrapOption)
                                              };
                                      });
                          });
              }), [input]);
}

var Common = {
  useCommonProps: useCommonProps,
  useOptions: useOptions,
  useLoadOptions: useLoadOptions,
  useLoadOptionsGroup: useLoadOptionsGroup
};

function useCreatableProps(input) {
  return {
          getNewOptionData: React.useCallback(Core__Option.map(input.getNewOptionData, (function (getNewOptionData) {
                      return function (opt) {
                        return ReactSelect.Options.wrapOption(getNewOptionData(opt));
                      };
                    })), [input.getNewOptionData])
        };
}

var Creatable = {
  useCreatableProps: useCreatableProps
};

function useSingleProps(input) {
  return {
          value: React.useMemo((function () {
                  return Core__Null.fromOption(Core__Option.map(input.value, ReactSelect.Options.wrapOption));
                }), [input.value]),
          onChange: React.useCallback(Core__Option.map(input.onChange, (function (onChange) {
                      return function (value) {
                        onChange(Caml_option.null_to_opt(Core__Null.map(value, ReactSelect.Options.unwrapOption)));
                      };
                    })), [input.onChange])
        };
}

var Single = {
  useSingleProps: useSingleProps
};

function useMultiProps(input) {
  return {
          value: React.useMemo((function () {
                  return input.value.map(ReactSelect.Options.wrapOption);
                }), [input.value]),
          onChange: React.useCallback(Core__Option.map(input.onChange, (function (onChange) {
                      return function (value) {
                        onChange(value.map(ReactSelect.Options.unwrapOption));
                      };
                    })), [input.onChange])
        };
}

var Multi = {
  useMultiProps: useMultiProps
};

var OptionsHelpers = {
  Common: Common,
  Creatable: Creatable,
  Single: Single,
  Multi: Multi
};

function AutocompleteV5$Select$Single(props) {
  var __status = props.status;
  var status = __status !== undefined ? __status : "Neutral";
  var selectRef = React.useRef(undefined);
  var match = useCommonProps({
        getOptionLabel: props.getOptionLabel,
        getOptionValue: props.getOptionValue,
        formatOptionLabel: props.formatOptionLabel
      });
  var match$1 = useSingleProps({
        value: props.value,
        onChange: props.onChange
      });
  var options = useOptions(props.options);
  return JsxRuntime.jsx(ReactSelect$1, {
              classNamePrefix: "autocomplete",
              controlShouldRenderValue: true,
              formatOptionLabel: match.formatOptionLabel,
              getOptionLabel: match.getOptionLabel,
              getOptionValue: match.getOptionValue,
              isClearable: props.isClearable,
              isDisabled: props.isDisabled,
              isSearchable: props.isSearchable,
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              placeholder: props.placeholder,
              styles: statusToStyles(status),
              onInputChange: props.onInputChange,
              classNames: props.classNames,
              ref: Caml_option.some(ref(undefined, selectRef)),
              options: options,
              value: match$1.value,
              onChange: match$1.onChange,
              isMulti: false
            });
}

var Single$1 = {
  make: AutocompleteV5$Select$Single
};

var Select = {
  Single: Single$1
};

function AutocompleteV5$AsyncSelect$Single(props) {
  var __status = props.status;
  var __controlShouldRenderValue = props.controlShouldRenderValue;
  var controlShouldRenderValue = __controlShouldRenderValue !== undefined ? __controlShouldRenderValue : true;
  var status = __status !== undefined ? __status : "Neutral";
  var match = useCommonProps({
        getOptionLabel: props.getOptionLabel,
        getOptionValue: props.getOptionValue
      });
  var match$1 = useSingleProps({
        value: props.value,
        onChange: props.onChange
      });
  var loadOptions = useLoadOptions(props.loadOptions);
  return JsxRuntime.jsx(Async, {
              classNamePrefix: "autocomplete",
              components: props.components,
              controlShouldRenderValue: controlShouldRenderValue,
              getOptionLabel: match.getOptionLabel,
              getOptionValue: match.getOptionValue,
              isClearable: props.isClearable,
              noOptionsMessage: Core__Option.map(props.noOptionsMessage, noOptionsMessage),
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              placeholder: props.placeholder,
              styles: statusToStyles(status),
              defaultOptions: props.defaultOptions,
              loadOptions: loadOptions,
              value: match$1.value,
              onChange: match$1.onChange,
              isMulti: false
            });
}

var Single$2 = {
  make: AutocompleteV5$AsyncSelect$Single
};

var AsyncSelect = {
  Single: Single$2
};

function AutocompleteV5$AsyncGroupSelect$Single(props) {
  var __status = props.status;
  var status = __status !== undefined ? __status : "Neutral";
  var selectRef = React.useRef(undefined);
  var match = useCommonProps({
        getOptionLabel: props.getOptionLabel,
        getOptionValue: props.getOptionValue
      });
  var match$1 = useSingleProps({
        value: props.value,
        onChange: props.onChange
      });
  var loadOptions = useLoadOptionsGroup(props.loadOptions);
  return JsxRuntime.jsx(Async, {
              classNamePrefix: "autocomplete",
              components: props.components,
              controlShouldRenderValue: true,
              getOptionLabel: match.getOptionLabel,
              getOptionValue: match.getOptionValue,
              isClearable: props.isClearable,
              isDisabled: props.isDisabled,
              noOptionsMessage: Core__Option.map(props.noOptionsMessage, noOptionsMessage),
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              placeholder: props.placeholder,
              styles: statusToStyles(status),
              classNames: props.classNames,
              ref: Caml_option.some(ref(props.forwardRef, selectRef)),
              loadOptions: loadOptions,
              value: match$1.value,
              onChange: match$1.onChange,
              isMulti: false
            });
}

var Single$3 = {
  make: AutocompleteV5$AsyncGroupSelect$Single
};

function AutocompleteV5$AsyncGroupSelect$Multi(props) {
  var __status = props.status;
  var status = __status !== undefined ? __status : "Neutral";
  var selectRef = React.useRef(undefined);
  var match = useCommonProps({
        getOptionLabel: props.getOptionLabel,
        getOptionValue: props.getOptionValue
      });
  var match$1 = useMultiProps({
        value: props.value,
        onChange: props.onChange
      });
  var loadOptions = useLoadOptionsGroup(props.loadOptions);
  return JsxRuntime.jsx(Async, {
              classNamePrefix: "autocomplete",
              components: props.components,
              controlShouldRenderValue: true,
              getOptionLabel: match.getOptionLabel,
              getOptionValue: match.getOptionValue,
              isClearable: props.isClearable,
              isDisabled: props.isDisabled,
              noOptionsMessage: Core__Option.map(props.noOptionsMessage, noOptionsMessage),
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              placeholder: props.placeholder,
              styles: statusToStyles(status),
              ref: Caml_option.some(ref(props.forwardRef, selectRef)),
              loadOptions: loadOptions,
              value: match$1.value,
              onChange: match$1.onChange,
              isMulti: true
            });
}

var Multi$1 = {
  make: AutocompleteV5$AsyncGroupSelect$Multi
};

var AsyncGroupSelect = {
  Single: Single$3,
  Multi: Multi$1
};

var components_Input = ReactSelect.Input.make;

var components = {
  Input: components_Input
};

function AutocompleteV5$AsyncCreatableSelect$Multi(props) {
  var __status = props.status;
  var status = __status !== undefined ? __status : "Neutral";
  var selectRef = React.useRef(undefined);
  var match = useCommonProps({
        getOptionLabel: props.getOptionLabel,
        getOptionValue: props.getOptionValue,
        formatOptionLabel: props.formatOptionLabel
      });
  var match$1 = useCreatableProps({
        getNewOptionData: props.getNewOptionData
      });
  var match$2 = useMultiProps({
        value: props.value,
        onChange: props.onChange
      });
  var loadOptions = useLoadOptions(props.loadOptions);
  return JsxRuntime.jsx(AsyncCreatable, {
              classNamePrefix: "autocomplete",
              components: components,
              controlShouldRenderValue: true,
              formatOptionLabel: match.formatOptionLabel,
              getOptionLabel: match.getOptionLabel,
              getOptionValue: match.getOptionValue,
              isClearable: props.isClearable,
              noOptionsMessage: Core__Option.map(props.noOptionsMessage, noOptionsMessage),
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              placeholder: props.placeholder,
              styles: statusToStyles(status),
              ref: Caml_option.some(ref(undefined, selectRef)),
              inputId: props.id,
              onPaste: props.onPaste,
              isValidNewOption: props.isValidNewOption,
              getNewOptionData: match$1.getNewOptionData,
              defaultOptions: props.defaultOptions,
              loadOptions: loadOptions,
              value: match$2.value,
              onChange: match$2.onChange,
              isMulti: true
            });
}

var Multi$2 = {
  make: AutocompleteV5$AsyncCreatableSelect$Multi
};

var AsyncCreatableSelect = {
  components: components,
  Multi: Multi$2
};

exports.Styles = Styles;
exports.SelectRef = SelectRef;
exports.Types = Types;
exports.Helpers = Helpers;
exports.OptionsHelpers = OptionsHelpers;
exports.Select = Select;
exports.AsyncSelect = AsyncSelect;
exports.AsyncGroupSelect = AsyncGroupSelect;
exports.AsyncCreatableSelect = AsyncCreatableSelect;
/*  Not a pure module */
